"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
/**
 * @deprecated use Div if you want a Div, this class doesn't create a label element, but a div for some reason
 */
class Label extends fmko_ts_common_1.Widget {
    constructor(text) {
        super();
        this.element = document.createElement("div");
        this.setText(text);
    }
    getInnerHTML() {
        return this.element.innerHTML;
    }
    getInnerText() {
        return this.element.innerText;
    }
    getTextContent() {
        return this.element.textContent;
    }
    setInnerHTML(html) {
        this.element.innerHTML = fmko_ts_common_1.HTMLUtils.sanitizeHTML(html);
    }
    setInnerText(text) {
        this.element.innerText = text;
    }
    setTextContent(text) {
        this.element.textContent = text;
    }
    /**
     * @deprecated Please consider using getInnerHTML, getInnerText, getTextContent instead
     */
    getText() {
        return this.element.innerHTML;
    }
    /**
     * @deprecated Please consider using setInnerHTML, setInnerText, setTextContent instead
     * @param text
     */
    setText(text) {
        if (text) {
            this.element.innerHTML = fmko_ts_common_1.HTMLUtils.sanitizeHTML(text);
        }
    }
}
exports.default = Label;
//# sourceMappingURL=Label.js.map